export default __webpack_public_path__ + "static/media/Smart-Lifestyle-Brochure.ab8779be.pdf";